module.exports = __webpack_public_path__ + "static/media/pic2.62fd985a.jpg";